const RemoveTrailingSlash = (str: string) => str.replace(/\/+$/, '');

export default RemoveTrailingSlash;
